export const SESSION_LIST = `
  query ListSessions {
    listSessions {
      end
      id
      isCurrent
      label
      name
      schoolYear
      start
    }
  }
`;
